/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
export const gtmEventTypes = {
  COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE: 'COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE',
}

export const gtmEvents = {
  [gtmEventTypes.COMPARE_VEHICLE_SELECTOR_CLICK_COMPARE]: ({model1, model2}) => ({
    type: gtmEventTypes.CLICK_COMPARE,
    event: 'reactjs.event',
    eventID: 'FED001',
    pageCategory: 'Compare Tool',
    pageAction: `Compare Home - Clicked Compare Cars "${model1.toUpperCase()}" and "${model2.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/compare-vehicle-selector-duck.js